module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--alert-dfdab1f06161733cd896b459eae8029a.svg";